import OwnerAPI from "../api/owner";

export const owners = {
    state: {
        ownerAddStatus: 0,
        ownerAddText: "",

        ownerEdit: {
            id: 0,
            lp: 0,
            name: '',
            role:'',
            mobile:'',
            email:'',
            card:'',
            permission:false,
            document:'',
            expiry:''
        },
        ownerEditDefault: {
            id: 0,
            lp: 0,
            name: '',
            role:'',
            mobile:'',
            email:'',
            card:'',
            permission:false,
            document:'',
            expiry:''
        },
        ownerEditLoadStatus: 0,
        ownerEditStatus: 0,
        ownerEditText: "",

        ownerDeleteStatus: 0,
        ownerDeleteText: "",

    },

    actions: {
        addOwner({ commit, state, dispatch }, data) {
            commit("setOwnerAddStatus", 1);
            commit("setOwnerAddText", "");

            OwnerAPI.postAddNewOwner(
                data.child_id,
                data.name,
                data.role,
                data.mobile,
                data.email,
                data.card,
                data.permission,
                data.document,
                data.expiry,
                data.default
                
            )
                .then(function(response) {
                    commit("setOwnerAddStatus", 2);
                    dispatch("loadChild",{slug:response.data.child_id});
                })
                .catch(function(error) {
                    commit("setOwnerAddStatus", 3);
                    commit("setOwnerAddText", error.response.data.errors);
                });
        },

        loadOwnerEdit({ commit }, data) {
            commit("setOwnerEditLoadStatus", 1);
            commit("setOwnerEditStatus", 0);
            commit("setOwnerEditText", "");

            OwnerAPI.getOwnerEdit(data.slug)
                .then(function(response) {
                    commit("setOwnerEdit", response.data);
                    commit("setOwnerEditLoadStatus", 2);
                })
                .catch(function() {
                    commit("setOwnerEdit", {});
                    commit("setOwnerEditLoadStatus", 3);
                });
        },
        loadOwnerEditDefault({ commit }) {
            commit("setOwnerEditDefault");
        },
        loadOwnerAddDefault({ commit }) {
            commit("setOwnerAddStatus", 0);
            commit("setOwnerAddText", "");
        },
        editOwner({ commit, state, dispatch }, data) {
            commit("setOwnerEditStatus", 1);

            OwnerAPI.putEditOwner(
                data.slug,
                data.child_id,
                data.name,
                data.role,
                data.mobile,
                data.email,
                data.card,
                data.permission,
                data.document,
                data.expiry,
                data.default
           
            )
                .then(function(response) {
                    commit("setOwnerEditStatus", 2);
                    dispatch("loadChild",{slug:response.data.child_id});
                })
                .catch(function(error) {
                    commit("setOwnerEditStatus", 3);
                    commit("setOwnerEditText", error.response.data.errors);
                });
        },
        addUserToOwner({ commit, state, dispatch }, data) {
            commit("setOwnerEditStatus", 1);

            OwnerAPI.putAddUserToOwner(
                data.slug,
                data.user_id,
                data.password,
            )
                .then(function(response) {
                    commit("setOwnerEditStatus", 2);
                    dispatch("loadChild",{slug:response.data.child_id});
                })
                .catch(function(error) {
                    commit("setOwnerEditStatus", 3);
                    commit("setOwnerEditText", error.response.data.errors);
                });
        },
        deleteUserFromOwner({ commit, state, dispatch }, data) {
            commit("setOwnerEditStatus", 1);

            OwnerAPI.putDeleteUserFromOwner(
                data.slug,
            )
                .then(function(response) {
                    commit("setOwnerEditStatus", 2);
                    dispatch("loadChild",{slug:response.data.child_id});
                })
                .catch(function(error) {
                    commit("setOwnerEditStatus", 3);
                    commit("setOwnerEditText", error.response.data.errors);
                });
        },
        resetUserPassword({ commit, state, dispatch }, data) {
            commit("setOwnerEditStatus", 1);

            OwnerAPI.putResetUserPassword(
                data.slug,
                data.password,
            )
                .then(function(response) {
                    commit("setOwnerEditStatus", 2);
                    dispatch("loadChild",{slug:response.data.child_id});
                })
                .catch(function(error) {
                    commit("setOwnerEditStatus", 3);
                    commit("setOwnerEditText", error.response.data.errors);
                });
        },
        copyOwner({ commit, state, dispatch }, data) {
            commit("setOwnerEditStatus", 1);

            OwnerAPI.postCopyOwner(
                data.slug,
            )
                .then(function(response) {
                    commit("setOwnerEditStatus", 2);
                    dispatch("loadChild",{slug:response.data.id});
                })
                .catch(function(error) {
                    commit("setOwnerEditStatus", 3);
                    commit("setOwnerEditText", error.response.data.errors);
                });
        },
    
        forceDeleteOwner({ commit, state, dispatch }, data) {
            commit("setOwnerDeleteStatus", 1);

            OwnerAPI.forceDeleteOwner(data.slug)
                .then(function(response) {
                    commit("setOwnerDeleteStatus", 2);
                    dispatch("loadChild",{slug:response.data.child_id});         
                })
                .catch(function() {
                    commit("setOwnerDeleteStatus", 3);
                });
        },
    },
    mutations: {
       
        setOwnerAddStatus(state, status) {
            state.ownerAddStatus = status;
        },
        setOwnerAddText(state, text) {
            state.ownerAddText = text;
        },
        setOwnerEdit(state, owner) {
            //pobiera dane do edycji
            state.ownerEdit = owner;
        
        },
        setOwnerEditDefault(state) {
            state.ownerEdit = { ...state.ownerEditDefault };
        },
        setOwnerEditStatus(state, status) {
            state.ownerEditStatus = status;
        },
        setOwnerEditText(state, text) {
            state.ownerEditText = text;
        },
        setOwnerEditLoadStatus(state, status) {
            state.ownerEditLoadStatus = status;
        },
        setOwnerDeleteStatus(state, status) {
            state.ownerDeleteStatus = status;
        },
        setOwnerDeletedText(state, text) {
            state.ownerDeleteText = text;
        }
    },

    getters: {
        getOwnerAddStatus(state) {
            return function(){
                return state.ownerAddStatus;
            } 
        },
        getOwnerAddText(state) {
            return state.ownerAddText;
        },
        getOwnerEdit(state) {
            return state.ownerEdit;
        },
        getOwnerEditStatus(state) {
          return function(){
            return state.ownerEditStatus;
          }
        },
        getOwnerEditing(state) {
            return state.ownerEdit.id > 0;
        },
        getOwnerEditText(state) {
            return state.ownerEditText;
        },
        getOwnerEditLoadStatus(state) {
            return state.ownerEditLoadStatus;
            
        },
        getOwnerDeleteStatus(state) {
            return function(){
                return state.ownerDeleteStatus;
            }
        },
        getOwnerDeleteText(state) {
            return state.ownerDeleteText;
        }
    }
};
